import React from 'react';
import { useHistory } from 'react-router-dom';
import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import EditFDConfigContext from 'contexts/EditFDConfigContext';
import AppContext from 'contexts/AppContext';
import FDConfigForm from 'forms/FDConfigForm';
import UserRoleType from 'types/enums/UserRoleType';

export default (): JSX.Element => {
  const history = useHistory();
  const { t } = useTranslation();
  const { selectedFDConfig } = React.useContext(EditFDConfigContext);
  const { authData } = React.useContext(AppContext);
  const isVenueEditor = authData?.user?.role === UserRoleType.VenueEditor;

  if (!selectedFDConfig) return <></>;
  if (isVenueEditor) {
    history.push('/private/welcome');
  }

  return (
    <div>
      <FDConfigForm config={selectedFDConfig} />
      <Box display="flex" justifyContent="center" width={1}>
        <Button className="btn-50" variant="contained" color="secondary" onClick={() => history.go(-1)}>
          {t('go-back')}
        </Button>
      </Box>
    </div>
  );
};
